// actions는 백엔드 API와 통신하는 역할
import * as types from './mutation-types'

// message.js
export const setMessages = ({ commit }, messageArray) => {
  commit(types.SET_MESSAGE, messageArray)
}

export const addMessage = ({ commit }, message) => {
  commit(types.ADD_MESSAGE, message)
}

export const clearMessages = ({ commit }) => {
  commit(types.CLEAR_MESSAGES)
}

export const arrangeMessages = ({ commit }) => {
  commit(types.ARRANGE_MESSAGES)
}

export const sliceMessages = ({ commit }, amount) => {
  commit(types.SLICE_MESSAGES, amount)
}

export const purifyMessages = ({ commit }, blacklistedName) => {
  commit(types.PURIFY_MESSAGES, blacklistedName)
}

// user.js
export const setUserinfo = ({ commit }, userInfo) => {
  commit(types.SET_USERINFO, userInfo)
}

// chatroom.js
export const setChatRooms = ({ commit }, roomInfo) => {
  commit(types.SET_CHATROOMS, roomInfo)
}



// WEBPACK FOOTER //
// ./src/vuex/actions.js